import { Component, DestroyRef, EventEmitter, inject, Input, OnDestroy, Output, ViewEncapsulation } from '@angular/core';

import { QPointContextbarService } from './contextbar.service/contextbar.service';
import { CommonModule } from '@angular/common';
import { GridContextBarOptionsComponent } from './grid-context-bar-options/grid-context-bar-options.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'qpoint-contextbar',
    templateUrl: './contextbar.component.html',
    styleUrls: ['./contextbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        CommonModule,
        GridContextBarOptionsComponent
    ]
})
export class QPointContextbarComponent implements OnDestroy {
  @Input() title: string;
  @Input() hideGridOptions = false;
  @Input() gridOptionsSectionTitle = 'common.grid.columns';
  @Output() public expandStateChanged = new EventEmitter<boolean>();

  private destroyRef = inject(DestroyRef);

  constructor(public contextbarService: QPointContextbarService) {
    contextbarService.contextbarVisibilityChanged
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isCollapsed) => {
        this.expandStateChanged.emit(!isCollapsed);
      });
  }

  ngOnDestroy() {
    this.contextbarService.collapseContextbar();
  }
}
